<template>

    <div class="input-label">

        <label class="label" :class="{'focused': bloomed, 'error': error}" @click="$refs.input.focus()">

            <span class="text-lRegular" v-show="!bloomed">{{ placeholder }}</span>

            <span class="text-sRegular" v-show="bloomed">{{ placeholder }}</span>

            <input ref="input"
                   class="input text-baseRegular color__charcoal"
                   :class="{'input-focused': bloomed}"
                   v-model="inputValue"
                   :name="placeholder"
                   :type="type"
                   :autocomplete="autocomplete"
                   :maxlength="maxlength"
                   :disabled="disable"
                   @focus="eventFocus"
                   v-on:blur="onBlur"
                   v-on:keyup.enter="$emit('pressEnter')">
        </label>

        <div class="error-bloc" v-show="error">

            <div class="error-label text-sSemibold color__white">{{ error }}</div>

        </div>
    </div>

</template>

<script>

export default {

    name: 'input-label',

    props: {

        placeholder: {
            type: String,
            default: ''
        },

        value: {
            type: String,
            default: ''
        },

        type: {
            type: String,
            default: 'text'
        },

        maxlength: {
            type: Number,
            default: 100
        },

        autocomplete: {
            type: String,
            default: 'off'
        },

        error: {
            type: String,
            default: ''
        },

        disable: {
            type: Boolean,
            default: false
        }
    },

    watch: {

        value(newValue, oldValue) {
            if (newValue !== oldValue && newValue !== this.inputValue) {
                this.inputValue = newValue
            }
        },
        inputValue(newValue, oldValue) {
            if (newValue !== oldValue && newValue !== this.value) {
                this.$emit('update', newValue)
            }
        }
    },

    computed: {
        bloomed() {
            return !!(this.focused || this.inputValue.length)
        }
    },


    data() {
        return {
            focused: false,
            inputValue: ''
        }
    },
    methods: {

        enter() {
            this.$emit('pressEnter')
        },

        onBlur() {
            this.$emit('blur')
            this.focused = false
        },

        eventFocus() {
            this.$emit('focus')
            this.focused = true
        }
    }
}

</script>

<style lang="scss" scoped>

.input-label {
    width: 100%;

    .label {
        width: 100%;
        padding: 17px 16px;
        border-radius: 12px;
        border: 1px solid $platinum;
        color: $neutralsMoon;
        text-align: start;
        cursor: pointer;
        display: flex;
        flex-direction: column;

        .input {
            height: 0;
            overflow: hidden;
            padding-block: 0;
        }

        .input-focused {
            height: auto;
        }
    }

    .focused {
        padding: 9px 16px;
    }

    .error {
        border-color: $raspberry;
    }

    .error-bloc {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;

        .error-label {
            margin-top: 8px;
            padding: 4px 8px;
            border-radius: 20px;
            background-color: $raspberry;
        }
    }
}


</style>
